// ─── ACKNOWLEDGEMENT MODAL — per-session legal gate ───────────────────────────
// Fires once per browser session before any terminal content is shown.
// Not dismissible by outside click or escape — the only exits are AFFIRM
// (after checking the box) or DECLINE (which redirects away). Acknowledgement
// is kept for the session only (see acknowledgement.js): a plain tab asks again,
// and a tab opened on a chart link honours it until the browser closes.

import { useState } from "react";
import { C, font } from "./core";

const GOLD = "#FFD700";

const POINTS = [
  "Nothing on this platform constitutes investment advice, a recommendation to buy or sell any security or financial instrument, or financial advice of any kind.",
  "All signal outputs, analyses, alerts, and data displays are for informational and research purposes only.",
  "The AI analyst feature provides automated data interpretation only. It is not a licensed financial advisor and its outputs do not constitute financial advice.",
  "Past signal patterns, historical data, and prior signal performance do not guarantee future results of any kind.",
  "Market data may be delayed, estimated, or derived. Always verify critical data through primary sources before making any decision.",
  "QUANT-SIGNAL is not a registered investment advisor, broker-dealer, or financial institution. We are not licensed to provide financial advice in any jurisdiction.",
  "You are solely responsible for any financial decisions you make. Consult a licensed financial advisor or attorney before making any investment or financial decision.",
  "By checking the box below and clicking AFFIRM, you confirm you have read, understood, and agree to these terms in their entirety.",
];

export function AcknowledgementModal({ onAffirm, onDecline }) {
  const [checked, setChecked] = useState(false);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.95)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        fontFamily: font,
      }}
    >
      <div
        style={{
          width: "min(560px, 94vw)",
          maxHeight: "90vh",
          overflowY: "auto",
          background: C.panel,
          border: `2px solid ${GOLD}`,
          borderRadius: 4,
          padding: 28,
        }}
      >
        {/* Title */}
        <div style={{ color: GOLD, fontSize: 16, fontWeight: 700, letterSpacing: "0.15em", marginBottom: 4 }}>
          IMPORTANT LEGAL NOTICE
        </div>
        <div style={{ color: GOLD, fontSize: 13, fontWeight: 700, letterSpacing: "0.1em", marginBottom: 16 }}>
          PLEASE READ CAREFULLY
        </div>

        {/* Intro body */}
        <div style={{ color: C.textMid, fontSize: 13, lineHeight: 1.8, marginBottom: 6 }}>
          QUANT-SIGNAL is a data intelligence and signal aggregation platform.
        </div>
        <div style={{ color: C.textMid, fontSize: 13, lineHeight: 1.8, marginBottom: 12 }}>
          By accessing this platform you acknowledge and agree that:
        </div>

        {/* Numbered points — gold, bold */}
        <ol style={{ margin: 0, paddingLeft: 22 }}>
          {POINTS.map((text, i) => (
            <li key={i} style={{ color: GOLD, fontWeight: 700, fontSize: 13, lineHeight: 1.8, marginBottom: 10 }}>
              {text}
            </li>
          ))}
        </ol>

        {/* Checkbox row */}
        <label
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: 10,
            marginTop: 18,
            marginBottom: 18,
            cursor: "pointer",
          }}
        >
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            style={{ width: 16, height: 16, accentColor: GOLD, marginTop: 2, flexShrink: 0, cursor: "pointer" }}
          />
          <span style={{ color: GOLD, fontWeight: 700, fontSize: 13, lineHeight: 1.6 }}>
            I have read and understand the above notice in its entirety.
          </span>
        </label>

        {/* Buttons */}
        <div style={{ display: "flex", gap: 10 }}>
          <button
            onClick={() => { if (checked) onAffirm(); }}
            disabled={!checked}
            style={{
              flex: 1,
              padding: "11px 0",
              borderRadius: 3,
              fontFamily: font,
              fontWeight: 700,
              fontSize: 14,
              letterSpacing: "0.06em",
              border: "none",
              background: checked ? GOLD : C.border,
              color: checked ? "#000000" : C.textDim,
              cursor: checked ? "pointer" : "not-allowed",
            }}
          >
            AFFIRM — ENTER TERMINAL
          </button>
          <button
            onClick={onDecline}
            style={{
              flex: 1,
              padding: "11px 0",
              borderRadius: 3,
              fontFamily: font,
              fontWeight: 700,
              fontSize: 14,
              letterSpacing: "0.06em",
              background: C.redBg,
              color: "#FF5252",
              border: "1px solid #FF5252",
              cursor: "pointer",
            }}
          >
            DECLINE — EXIT
          </button>
        </div>
      </div>
    </div>
  );
}
